import { jsx } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { allowedLinks } from "@nxplatform/platform-settings/locale-setup.routes";
const guardedRoutesHook = (routes, props) => {
  const {
    isBlocked,
    isGviveMigrationInProgress
  } = props;
  if (isBlocked) {
    return [
      {
        path: "*",
        element: /* @__PURE__ */ jsx(
          Navigate,
          {
            to: allowedLinks.blockedVerification,
            replace: true
          }
        )
      }
    ];
  }
  if (isGviveMigrationInProgress) {
    return [
      {
        path: "*",
        element: /* @__PURE__ */ jsx(
          Navigate,
          {
            to: allowedLinks.registrationMigrationGvive,
            replace: true
          }
        )
      }
    ];
  }
  return routes;
};
export {
  guardedRoutesHook
};
